// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_fp-0";
export var optionCard = "_fp-1";